/**
 * Format the given array of string to a string usable of aria attributes
 */
export const formatAriaIds = (ids: Array<string> = []) => (ids.length > 0 ? ids.join(' ') : undefined);
